import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-323" data-mp="3fycofh2u5v85">
      <div className="mx-auto max-w-5xl" data-id="element-324" data-mp="3azt2hgo8sjfs">
        <div id="testimonials-title" data-id="element-325" data-mp="3ayqb77n0cezc">
          <SectionHeading eyebrow="What people are saying" title="Real practice, not more theory" data-id="element-326" data-mp="36z95cd3o5ftn" />
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-327" data-mp="31z3bqrdu9j8x">
          {testimonials.map(t => <li key={t.name + t.headline} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-328" data-mp="2x1bi9sxjpp2m">
              <div className="flex items-center gap-4" data-id="element-329" data-mp="2s39puhe8cdeh">
                <img src={t.image} alt={`Photo of ${t.name}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-330" data-mp="v96nm9onwdo7" />
                <div data-id="element-331" data-mp="h4dcylqnjo46">
                  <p className="font-bold text-ink" data-id="element-332" data-mp="h8181pbqwil0">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-333" data-mp="m5syeewqrwn3">{t.country}</p>
                  <div className="mt-1 flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-334" data-mp="780mrxubfse6">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-335" data-mp="c8y0ny8am09v" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <p className="mt-5 font-serif text-xl font-bold leading-snug text-brand-800" data-id="element-336" data-mp="14uzkmbwqv6dn">{t.headline}</p>
              <p className="mt-3 text-[16px] leading-relaxed text-ink/80" data-id="element-337" data-mp="q63c6dqrzrci">{t.text}</p>
            </li>)}
        </ul>

        <SectionCta label="I want to start my practice" data-id="element-338" data-mp="v3d1lte6030c" />
      </div>
    </section>;
}